<template>
  <div class="distributor-box">
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005444')">
              <morePlatforms
                ref="platform"
                :defaultPlatform="defaultPlatform"
                @handlePlatformData="handlePlatformData"
                @selectPlatform="selectPlatform">
              </morePlatforms>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')" prop="searchValue">
              <Input v-model.trim="pageParams.searchValue" clearable :placeholder="$t('key1005834')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001522')">
              <local-tabButton :tabButtonList="enableStatusList" @selectStatus="enableStatusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005430')">
              <local-tabButton :tabButtonList="platformAccountStatusList" @selectStatus="platformAccountStatusBtn"></local-tabButton>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <Button class="mr15" type="primary" v-if="getPermission('ymsPlatformAccount_applyAuth')" @click="addStoreBtn">{{ $t('key1001329') }}</Button>
      <!--YMS-11993需求调整需要暂时屏蔽掉-->
      <!--      <Button class="mr15" type="primary" v-if="getPermission('ymsPlatformAccount_applyAuth')" @click="openAuthorizedStore">管理已授权店铺</Button>-->
    </div>
    <div v-if="pageParams.platformId === 'ebay'" class="operation-box" style="font-size: 15px; color: #333">
      1. {{ $t('key1005835') }}<br/>
      2. {{ $t('key1005836') }}
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="tbableDom"
        highlight-row
        border
        class="platformLogo"
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--管理已授权店铺弹窗-->
    <authorizedStore ref="authorizedStore" @getList="search"></authorizedStore>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="DISTRIBUTOR" :showPage="true"></commonLogModal>
    <!--购买店铺额度弹窗-->
    <purchaseStoreLimitModal ref="purchaseStoreLimit" @updateData="pageParamsStatus = true"></purchaseStoreLimitModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import morePlatforms from "@/components/common/morePlatforms";
import authorizedStore from "@/components/common/authorizedStore";
import commonLogModal from "@/components/common/commonLogModal";
import {ENABLEDISABLESTATUS} from "@/utils/enum";
import {commonLocalStorage, EventBus, isAlibabaDistributor, isJSON} from "@/utils/common";
import purchaseStoreLimitModal from "@/views/distributor/components/storeManage/purchaseStoreLimitModal.vue";

export default {
  name: "platformStoreList",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        platformId: null,
        searchValue: '',
        status: null,
        platformAccountStatus: null,
        pageNum: 1,
        pageSize: 100
      },
      total: 0,
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001324'),
          key: 'code',
          align: 'left',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001786'),
          minWidth: 150,
          key: 'platform',
          align: 'left',
          render(h, params) {
            if (v.platformImagesData.length > 0) {
              let platformId = params.row.platformId;
              let logoPath = '';
              v.platformImagesData.map((item) => {
                if (item.platformId === platformId) {
                  logoPath = item.logoPath;
                }
              });
              return h('img', {
                attrs: {
                  src: logoPath,
                  onerror: v.failPlaceholder
                },
                style: {
                  width: '107px',
                  height: '42px',
                  objectFit: 'cover',
                  verticalAlign: 'middle',
                  margin: '5px 0'
                }
              });
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003502'),
          key: 'sites',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let ymsPlatformAccountSites = params.row.ymsPlatformAccountSites || [];
            let nameList = [];
            if (ymsPlatformAccountSites.length > 0) {
              ymsPlatformAccountSites.map((item) => {
                if (item.name) {
                  nameList.push(item.name);
                }
              });
            }
            if (nameList.length > 0) {
              return h('span', nameList.join('、'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001325'),
          key: 'name',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005821'),
          key: 'platformAccountStatus',
          align: 'left',
          minWidth: 240,
          resizable: true,
          render(h, params) {
            let isShopeeChildAccount = !!(params.row.parentYmsPlatformAccountId && params.row.platformId === 'shopee'); // 是否为shopee子账号
            if (params.row.ymsPlatformAccountTokens) {
              let data = params.row.ymsPlatformAccountTokens;
              if (data) {
                return h('div', data.map(i => {
                  return h('p', {class: 'flex align-items-center flex-wrap'}, [
                    h('span', {
                      domProps: {
                        title: i.authName,
                      }
                    }, i.authName),
                    h('span', {
                      style: {
                        color: i.status === 1 ? 'green' : 'red'
                      },
                      class: 'ml5 mr5',
                    }, i.status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001326') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001327')),
                    (i.authDescription && !isShopeeChildAccount) ? h('Poptip', {
                      props: {
                        'word-wrap': true,
                        trigger: 'hover',
                        content: i.authDescription
                      }
                    }, [h('Icon', {
                      props: {
                        size: 16,
                        type: 'ios-help-circle'
                      }
                    })]) : '',
                    (!isShopeeChildAccount && i.authType.includes('oauth') && v.getPermission('ymsPlatformAccount_applyAuth')) ? h('span', {
                      class: 'goAuth',
                      on: {
                        'click'() {
                          v.editStoreBtn(params.row.platformId, params.row.ymsPlatformAccountId, i.authType, 'toauth');
                        }
                      }
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005822')) : ''
                  ]);
                }));
              }

            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005823'),
          key: 'createdTime',
          align: 'left',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005824'),
          key: 'updatedTime',
          align: 'left',
          minWidth: 350,
          render: (h, params) => {
            let list = [];
            let ymsPlatformAccountTokens = params.row.ymsPlatformAccountTokens || [];
            if (ymsPlatformAccountTokens.length > 0) {
              // 根据 authType 进行去重，并且只保留 updatedTime 最新的数据
              const newData = ymsPlatformAccountTokens.reduce((accumulator, current) => {
                const existingData = accumulator.find(item => item.authType === current.authType);
                if (existingData) {
                  if (current.updatedTime > existingData.updatedTime) {
                    existingData.updatedTime = current.updatedTime;
                  }
                } else {
                  accumulator.push(current);
                }
                return accumulator;
              }, []);
              if (newData && newData.length > 0) {
                newData.map((item) => {
                  let name = item.authName + '：';
                  let time = item.updatedTime ? v.$uDate.dealTime(item.updatedTime, 'fulltime') : '';
                  list.push(h('p', {class: 'mt2 mb2'}, name + time));
                });
              }
              return h('div', list);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005825'),
          key: 'platformAccountStatus',
          resizable: true,
          minWidth: 100,
          align: 'left',
          render(h, params) {
            let status = params.row.status;
            return h('div', {
              style: {
                color: status === 1 ? 'green' : 'red'
              }
            }, status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005826'),
          key: 'expirationTime',
          align: 'left',
          minWidth: 180,
          render: (h, params) => {
            let siteType = params.row.siteType; // 站点类型 YMS、ALIGJ
            let buyType = params.row.buyType; // 购买类型 1需购买 2无需购买
            let buyTimeoutLeftTime = v.$uDate.dealTime(params.row.buyTimeoutLeftTime, 'fulltime') || null;
            let text = '-';
            if (siteType === 'ALIGJ' && buyType === 2) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005827');
            }
            if (siteType === 'ALIGJ' && buyType === 1 && !buyTimeoutLeftTime) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005828');
            }
            if (siteType === 'ALIGJ' && buyType === 1 && buyTimeoutLeftTime) {
              let expireDate = new Date(buyTimeoutLeftTime);
              let currentDate = new Date();
              if (currentDate > expireDate) {
                text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005829');
              } else {
                text = buyTimeoutLeftTime;
              }
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'left',
          fixed: 'right',
          width: 150,
          render(h, params) {
            let expiredOrNotTalg = false;
            let status = params.row.status === 1;
            let isShopeeChildAccount = !!(params.row.parentYmsPlatformAccountId && params.row.platformId === 'shopee'); // 是否为shopee子账号
            let siteType = params.row.siteType; // 站点类型 YMS、ALIGJ
            let buyType = params.row.buyType; // 购买类型 1需购买 2无需购买
            let buyTimeoutLeftTime = v.$uDate.dealTime(params.row.buyTimeoutLeftTime, 'fulltime') || null;
            if (siteType === 'ALIGJ' && buyType === 1 && buyTimeoutLeftTime) {
              let expireDate = new Date(buyTimeoutLeftTime);
              let currentDate = new Date();
              expiredOrNotTalg = currentDate > expireDate;
            }
            let ymsPlatformAccountId = params.row.ymsPlatformAccountId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005830'),
                    show: isAlibabaDistributor() && siteType === 'ALIGJ' && buyType === 1 && !buyTimeoutLeftTime,
                    clickFn: () => {
                      v.$refs['purchaseStoreLimit'].initPurchaseStoreLimitData(ymsPlatformAccountId, 'buy');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005831'),
                    show: isAlibabaDistributor() && expiredOrNotTalg && siteType === 'ALIGJ',
                    clickFn: () => {
                      v.$refs['purchaseStoreLimit'].initPurchaseStoreLimitData(ymsPlatformAccountId, 'renew');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: !isShopeeChildAccount && v.getPermission('ymsPlatformAccount_applyAuth'),
                    clickFn: () => {
                      v.editStoreBtn(params.row.platformId, ymsPlatformAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status && v.getPermission('ymsPlatformAccount_disable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row.status, ymsPlatformAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: !status && v.getPermission('ymsPlatformAccount_enable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row.status, ymsPlatformAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsPlatformAccountId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      enableStatusList: ENABLEDISABLESTATUS,
      platformAccountStatusList: [
        {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005436')},
        {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005437')},
      ],
      platformImagesData: [],
      defaultPlatform: null,
      temuChoiceLogoPath: require('@/assets/images/platform/temu_choice.png')
    };
  },
  mounted() {
    EventBus.$on('updatePlatformStoreList', (data) => {
      let obj = JSON.parse(data) || '';
      this.defaultConditionQuery(obj);
    });
  },
  created() {
    this.handleColumns();
    let obj = commonLocalStorage.getItem('platformStoreListQuery');
    if (obj) {
      this.defaultPlatform = obj.platformId;
    }
  },
  methods: {
    handlePlatformData(data) {
      let newData = data || [];
      if (data.length > 0) {
        // temu半托管的logo图片单独处理
        newData.map((item) => {
          if (item.platformId === 'temu_choice') {
            item.logoPath = this.temuChoiceLogoPath;
          }
        });
        this.platformImagesData = newData;
        this.pageParams.platformId = newData[0].platformId;
        let obj = commonLocalStorage.getItem('platformStoreListQuery');
        this.defaultConditionQuery(obj, newData);
      }
    },
    // 触发带着默认条件查询
    defaultConditionQuery(obj) {
      let v = this;
      if (obj) {
        v.platformAccountStatusBtn(2, 0);
        v.pageParams.platformId = obj.platformId;
        if (v.$refs['platform']) {
          v.$refs['platform'].selectPlatformFun(obj.platformId);
        }
        v.initFun();
        setTimeout(() => {
          v.$store.commit('updateDistributorMenu', false);
          commonLocalStorage.removeItem('platformStoreListQuery');
        }, 2000);
      } else {
        v.initFun();
      }
    },
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.initWebSocket();
        await this.search();
      })();
    },
    /**
     * 注册店铺授权结果使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
v.webSocketListenerKey = `platform-store-list-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data) {
          if (data.type === 'auth') {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005832'));
          } else if (data.type === 'save') {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005833'));
          }
          if (data.msg && isJSON(data.msg)) {
            let obj = JSON.parse(data.msg);
            v.pageParams.platformId = obj.platformId;
            v.selectPlatform(obj.platformId);
          } else {
            v.pageParamsStatus = true;
          }
        }
      }, v);
    },

    /**
     * 清理店铺授权结果监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 获取店铺列表数据
    getList() {
      let v = this;
      if (v.getPermission('ymsPlatformAccount_query')) {
        v.tableData = [];
        v.total = 0;
        v.tableLoading = true;
        v.axios.post(api.post_ymsPlatformAccount_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            v.total = data.total;
            v.updateTableDom('tbableDom');
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选取启用状态
    enableStatusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.enableStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 选取授权状态
    platformAccountStatusBtn(index, value) {
      let v = this;
      v.pageParams.platformAccountStatus = value;
      v.platformAccountStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 管理已授权店铺
    openAuthorizedStore() {
      this.$refs.authorizedStore.getAuthorizedStore({
        platformId: this.pageParams.platformId
      });
    },
    // 添加店铺
    addStoreBtn() {
      this.authorizedOperation(this.pageParams.platformId);
    },
    // 选取平台
    selectPlatform(platformId) {
      this.pageParams.platformId = platformId;
      this.pageParamsStatus = true;
    },
    // 编辑店铺
    editStoreBtn(platformId, ymsPlatformAccountId, authType, action) {
      this.authorizedOperation(platformId, ymsPlatformAccountId, authType, action);
    },
    // 新增、编辑店铺需要调申请授权接口重定向到三方授权系统进行操作
    authorizedOperation(platformId, ymsPlatformAccountId = null, authType = '', action = 'edit') {
      let v = this;
      let query = {
        "action": action, // 行动(toauth(返回授权地址)、edit(返回表单地址))
        "ymsPlatformAccountId": ymsPlatformAccountId, // 授权账号TOKEN流水号
        "currentAuthType": authType,
        "platformId": platformId
      };
      if (['tiktok'].includes(platformId)) {
        query.authTypes = ['oauth1'];
      } else if (['ebay'].includes(platformId)) {
        query.authTypes = ['oauth2'];
      }
      v.axios.post(api.post_ymsPlatformAccount_applyAuth, query).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            window.open(data.redirectUrl, '_blank');
          } else {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005425'));
            return false;
          }
        }
      });
    },
    // 启用、停用按钮
    enableDisableBtn(status, ymsPlatformAccountId) {
      let v = this;
      let url = '';
      let text = '';
      // 停用
      if (status === 1) {
        url = api.put_ymsPlatformAccount_disable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472');
      }
      // 启用
      else {
        url = api.put_ymsPlatformAccount_enable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473');
      }
      v.axios.put(url, ymsPlatformAccountId).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(text);
          v.pageParamsStatus = true;
        }
      });
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.platformAccountStatusBtn(0, null);
      v.enableStatusBtn(0, null);
      v.getList();
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.optionBtnWidth = [];
      let hideKeyColumns = [];
      if (!isAlibabaDistributor()) {
        hideKeyColumns = ['expirationTime'];
      }
      v.tableColumns = v.originalColumns.filter((item) => {
        return !hideKeyColumns.includes(item.key);
      });
      v.updateTableDom('tbableDom');
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
beforeDestroy() {
    EventBus.$off('updatePlatformStoreList');
    this._isDestroyed = true;
  },
  components: {
    morePlatforms,
    authorizedStore,
    commonLogModal,
    purchaseStoreLimitModal
  }
};
</script>

<style>
.ml5 {
  margin-left: 5px;
}

.goAuth {
  color: #2D8CF0;
  margin-left: 5px;
  cursor: pointer;
  white-space: nowrap;
}

.goAuth:hover {
  text-decoration: underline;
}
</style>
